/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProjectShareDTO } from '../models/ProjectShareDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ProjectShareService {

    /**
     * @param userId 
     * @param projectId 
     * @param projectFolderId 
     * @returns boolean Success
     * @throws ApiError
     */
    public static getProjectShareValidateShareUser(
userId: number,
projectId?: number,
projectFolderId?: number,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ProjectShare/ValidateShareUser/{userId}/{projectId}/{projectFolderId}',
            path: {
                'userId': userId,
            },
            query: {
                'projectId': projectId,
                'projectFolderId': projectFolderId,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns ProjectShareDTO Success
     * @throws ApiError
     */
    public static postProjectShare(
requestBody?: ProjectShareDTO,
): CancelablePromise<ProjectShareDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ProjectShare',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

}
